import lodash from "lodash";
import { createColumnInput, createColumnSelect } from "../../../../../components/table/c-table.logic";
import i18n from "../../../../../i18n";
import store from "../../../../../store";
import { conditionFormChecker, copyForm, putField } from "../../../../../utils/form";
import { callRequestStatus, callRequestType } from "../../../storage-location/request/request.section";
import {
    createFieldInput,
    createFieldSelect,
    createFieldTextArea,
    createFieldTreeSelect
} from "../../../../../components/input/template-builder/template-builder.logic";
import { Modal } from "ant-design-vue";
import router from "../../../../../router";
import { randomUuid } from "../../../../../utils/util";
import { defineAsyncComponent } from "vue";

const CIcon = defineAsyncComponent(() => import("../../../../../components/icon/CIcon"));

export const callUserObjective = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "USER_OBJECTIVE", value: searchQuery }).then(items => items.filter(item => ["1", "2"].includes(item.key)));
export const callDepartment = ({ searchQuery }) => store.dispatch("resource/v1/master/department/cacheFindAll", { searchQuery });
export const callDepartmentTree = () => store.dispatch("resource/v1/master/department/cacheFindAllWithChildren", {});
export const callRequestDoc = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "REQUEST_DOC", value: searchQuery });

export const callSamplingAnalysis = ({ approveCode, informApproveCode, userInfo }) => {
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "isTemp", type: "Boolean", operator: "=", value: false },
        { name: "refStatus.key", type: "String", operator: "=", value: "complete" },
        { name: "refDepartment.id", type: "UUID", operator: "=", value: userInfo.refDepartment?.id },
    ];
    if (informApproveCode) {
        where.push({ name: "refRelease.refInspection.refInformTemp.approveCode", type: "String", operator: "like", value: informApproveCode });
    } else if (approveCode) {
        where.push({ name: "approveCode", type: "String", operator: "like", value: approveCode });
    }
    return store
        .dispatch("resource/v1/transaction/samplingAnalysis/search", {
            criteria: {
                isDistinct: true,
                select: ["id", "approveCode", "refUserCompany.id", "refUserCompany.fullNameTh",
                    "refRelease.id",
                    "refRelease.approveCode",
                    "refRelease.refInspection.id",
                    "refRelease.refInspection.approveCode",
                    "refRelease.refInspection.refInformTemp.id",
                    "refRelease.refInspection.refInformTemp.approveCode",
                ],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "approveCode", type: "DESC" }]
            }
        })
        .then(page => page.data);
};

export const callSamplingAnalysisFull = ({ id }) => {
    const criteria = {
        select: [
            "**",
            `refUserCompany.**`,
            `refUser.**`,
            `refDepartment.*`,
        ],
        page: 0,
        size: 1,
        where: [{ name: "id", type: "UUID", operator: "=", value: id }],
        children: [
            { name: "attachments", select: ["**"], page: 0, size: 1000000, sort: [{ name: "createDate", type: "ASC" }] },
            {
                name: "products",
                select: ["**",
                    "refSendSamplingProduct.refSampling.refReleaseProduct.refRelease.refInspection.approveCode",
                    "refSendSamplingProduct.refSampling.refReleaseProduct.refInspectionProduct.refInformProduct.refHazObject.nameTh",
                    "refSendSamplingProduct.refSampling.refReleaseProduct.refInspectionProduct.refInformProduct.refHaz.tradeNameTh",
                    "refSendSamplingProduct.refSampling.refReleaseProduct.refInspectionProduct.refInformProduct.refHaz.refSubStanceTypeMain.value",
                    "refSendSamplingProduct.refSampling.refSizeUnit.value",
                    "refSendSamplingProduct.refSampling.refQtyUnit.value",
                ],
                page: 0,
                size: 1000000,
                sort: [{ name: "createDate", type: "ASC" }]
            }
        ]
    };
    return store.dispatch("resource/v1/transaction/samplingAnalysis/search", { criteria, })
        .then(page => page.data[0])
};


export const callSendSampling = ({ approveCode, userInfo }) => {
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "isTemp", type: "Boolean", operator: "=", value: false },
        { name: "refStatus.key", type: "String", operator: "=", value: "complete" },
        { name: "refDepartment.id", type: "UUID", operator: "=", value: userInfo.refDepartment?.id },
    ];
    where.push({ openBucket: true, name: "refSamplingAnalysis.id", type: "UUID", operator: "=", value: null });
    where.push({ closeBucket: true, logic: "OR", name: "refSamplingAnalysis.refLastRequestTemp.refStatus.key", type: "String", operator: "in", value: ['cancel', 'notApprove'] });
    if (approveCode) {
        where.push({ name: "approveCode", type: "String", operator: "like", value: approveCode });
    }
    return store
        .dispatch("resource/v1/transaction/sendSampling/search", {
            criteria: {
                isDistinct: true,
                select: ["id", "approveCode",
                    `refSamplingAnalysis.**`,
                    `refSamplingAnalysis.refLastRequestTemp.**`,
                ],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "approveCode", type: "DESC" }]
            }
        })
        .then(page => page.data);
};

export const callSendSamplingFull = ({ id }) => {
    const criteria = {
        select: [
            "**",
            `refUserCompany.**`,
            `refUser.**`,
            `refDepartment.*`,
        ],
        page: 0,
        size: 1,
        where: [{ name: "id", type: "UUID", operator: "=", value: id }],
        children: [
            {
                name: "products",
                select: ["**",
                    "refSampling.id",
                    "refSampling.approveCode",
                    "refSampling.manufacturer",
                    "refSampling.manufactureDate",
                    "refSampling.importer",
                    "refSampling.refSizeUnit.*",
                    "refSampling.refQtyUnit.*",
                    "refSampling.refReleaseProduct.refInspectionProduct.refInformProduct.refHazObject.id",
                    "refSampling.refReleaseProduct.refInspectionProduct.refInformProduct.refHazObject.nameTh",
                    "refSampling.refReleaseProduct.refInspectionProduct.refInformProduct.refHaz.id",
                    "refSampling.refReleaseProduct.refInspectionProduct.refInformProduct.refHaz.refSubStanceTypeMain.value",
                    "refSampling.refReleaseProduct.refInspectionProduct.refInformProduct.refHaz.tradeNameTh",
                    "refSampling.refReleaseProduct.refInspectionProduct.refInformProduct.refHaz.approveCode",
                ],
                page: 0,
                size: 1000000,
                sort: [{ name: "createDate", type: "ASC" }]
            }
        ]
    };
    return store.dispatch("resource/v1/transaction/sendSampling/search", { criteria, }).then(page => page.data[0])
};

export const createColumns = () => {
    const columns = [
        createColumnSelect({
            title: () => i18n.global.t("model.request.refRequestType"),
            dataIndex: "refRequestType.value",
            customRender: ({ record }) => <div>
                <span>{record.refRequestType?.value}</span>
                {record.isSignCa ? <CIcon class="ml-1" file="sign.svg"></CIcon> : null}
            </div>,
            inputProp: () => ({ list: callRequestType, optLabel: "value" }),
            search: { name: "refRequestType.id" },
            align: "center",
        }),
        createColumnInput({ title: () => i18n.global.t("model.request.draftCode"), dataIndex: "draftCode", align: "center" }),
        createColumnInput({ title: () => i18n.global.t("model.request.requestCode"), dataIndex: "requestCode", align: "center" }),
        createColumnInput({
            title: () => i18n.global.t("views.request.approveCode"),
            dataIndex: "refSamplingAnalysis.approveCode",
            align: "center"
        }),
        createColumnInput({
            title: () => i18n.global.t("model.samplingAnalysis.products"),
            dataIndex: "refSamplingAnalysisTemp.products",
            align: "center",
            customRender: ({ record }) => {
                const labels = record.refSamplingAnalysisTemp?.products?.map(d => {
                    return <div>{ d.refSendSamplingProduct?.refSampling?.approveCode }</div>
                }) || [];
                return <>{...labels}</>
            }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.samplingAnalysis.refDepartment"),
            dataIndex: "refDepartment.nameTh",
            inputProp: () => ({ list: callDepartment, optLabel: "nameTh" }),
            search: { name: "refDepartment.id" },
            align: "center",
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.request.refStatus"),
            dataIndex: "refStatus.value",
            inputProp: () => ({
                list: ({searchQuery}) => callRequestStatus({ searchQuery }),
                optLabel: "value"
            }),
            search: { name: "refStatus.id" },
            align: "center"
        })
    ];
    return columns;
};

export const createField = ({ props, data, key }) => {
    const fields = [
        ...createFieldRequest({ props, data, key }),
    ];
    return fields;
};

export const createFieldRequest = ({ props, data, key }) => {
    const { viewOnly, requestTypeKeys } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refRequestType`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.refRequestType"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refRequestType,
                            "onUpdate:value": value => {
                                model.refRequestType = value;
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) => callRequestType({ searchQuery }).then(d=>d.filter(d2 => requestTypeKeys?.includes(d2?.key))),
                            optLabel: "value",
                            allowClear: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}requestCode`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.requestCode"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.requestCode,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refSamplingAnalysisTemp.approveCode`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.approveCode"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refSamplingAnalysisTemp?.approveCode,
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refSamplingAnalysis`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.samplingAnalysis.referDoc"),
                inputProp: ({ field }) => {
                    return lodash.merge(
                        {
                            value: model.refSamplingAnalysis,
                            "onUpdate:value": value => {
                                const oldValue = model.refSamplingAnalysis;
                                model.refSamplingAnalysis = value;
                                if (oldValue) {
                                    Modal.confirm({
                                        title: i18n.global.t("views.request.modal.change", {
                                            text: i18n.global.t("model.storageLocation.approveCode")
                                        }),
                                        autoFocusButton: "cancel",
                                        onOk: () => cloneSamplingAnalysis({ props, model, id: value?.id }),
                                        onCancel: () => {
                                            model.refSamplingAnalysis = oldValue;
                                        }
                                    });
                                } else {
                                    cloneSamplingAnalysis({ props, model, id: value?.id });
                                }
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) => callSamplingAnalysis({ approveCode: searchQuery, userInfo: store.state.resource.auth.info?.user }),
                            renderLabel: ({ item }) => (
                                <div>
                                    {item.approveCode} - {item.refUserCompany?.fullNameTh}
                                </div>
                            ),
                            allowClear: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    );
                },
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refSamplingAnalysisTemp.refSendSampling`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.samplingAnalysis.refSendSampling"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refSamplingAnalysisTemp?.refSendSampling,
                            "onUpdate:value": value => {
                                const oldValue = model.refSamplingAnalysisTemp?.refSendSampling;
                                model.refSamplingAnalysisTemp.refSendSampling = value;
                                if (oldValue) {
                                    Modal.confirm({
                                        title: i18n.global.t("views.request.modal.change", {
                                            text: i18n.global.t("model.storageLocation.approveCode")
                                        }),
                                        autoFocusButton: "cancel",
                                        onOk: () => cloneSendSampling({ props, data, key, model, id: value?.id }),
                                        onCancel: () => {
                                            model.refSamplingAnalysisTemp.refSendSampling = oldValue;
                                        }
                                    });
                                } else {
                                    cloneSendSampling({ props, data, key, model, id: value?.id });
                                }
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) => callSendSampling({ approveCode: searchQuery, userInfo: store.state.resource.auth.info?.user }),
                            optLabel: "approveCode",
                            allowClear: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTreeSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refSamplingAnalysisTemp.refDepartment`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.samplingAnalysis.refDepartment"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refDepartment,
                            "onUpdate:value": value => {
                                model.refDepartment = value
                                model.refSamplingAnalysisTemp.refDepartment = value
                            },
                            disabled: viewOnly,
                            list: callDepartmentTree,
                            optLabel: "nameTh"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTreeSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refSamplingAnalysisTemp.refAnalysisDepartment`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.samplingAnalysis.refAnalysisDepartment"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refSamplingAnalysisTemp.refAnalysisDepartment,
                            "onUpdate:value": value => (model.refSamplingAnalysisTemp.refAnalysisDepartment = value),
                            disabled: viewOnly,
                            list: callDepartmentTree,
                            optLabel: "nameTh"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}lastStatus.forRequestRemark.0.remark`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("views.request.samplingAnalysisInfo.descToApprove"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.lastStatus.forRequestRemark?.[0]?.remark,
                            "onUpdate:value": value => {model.lastStatus.forRequestRemark[0].remark = value},
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}lastStatus.forApproveRemark.0.remark`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("views.request.samplingAnalysisInfo.descToRequest"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.lastStatus.forApproveRemark?.[0]?.remark,
                            "onUpdate:value": value => (model.lastStatus.forApproveRemark[0].remark = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
        ]
    });
};

export const cloneSamplingAnalysis = ({ props, model, id }) => {
    if (id) {
        callSamplingAnalysisFull({ props, id }).then(samplingAnalysis => {
            const refSamplingAnalysisTemp = copyForm({ form: { ...samplingAnalysis, approveCode: null, isTemp: true } });
            if (id) {
                refSamplingAnalysisTemp?.attachments?.forEach((d, index) => (d.refRealId = samplingAnalysis.attachments[index].id));
                refSamplingAnalysisTemp?.products?.forEach((d, index) => {
                    d.refReal = { id: samplingAnalysis.products[index].id }
                    d.refSamplingAnalysis = null;
                });
            }
            router.push({
                name: router.currentRoute.value.name,
                params: { props: JSON.stringify({ form: { ...model, refDepartment: samplingAnalysis?.refDepartment, refSamplingAnalysisTemp } }) },
                query: { _timestamp: new Date().getTime() }
            });
        });
    } else {
        router.push({
            name: router.currentRoute.value.name,
            params: { props: JSON.stringify({ forceDefault: true, form: model }) },
            query: { _timestamp: new Date().getTime() }
        });
    }
};

export const cloneSendSampling = ({ props, data, model, id }) => {
    if (id) {
        data.isLoadDefaultFormDone = false;
        callSendSamplingFull({ props, id }).then(sendSampling => {
            model?.refSamplingAnalysisTemp?.products?.forEach(d=>d.isDelete=true);
            const products = sendSampling?.products?.map((d, index) => ({
                    id: null,
                    _id: randomUuid(),
                    refSendSamplingProduct: lodash.cloneDeep(sendSampling.products[index]),
                    refTopic: lodash.cloneDeep(sendSampling.products[index].refTopic),
                    refMethod: lodash.cloneDeep(sendSampling.products[index].refMethod),
                    refSizeUnit: lodash.cloneDeep(sendSampling.products[index].refSampling.refSizeUnit),
                    refQtyUnit: lodash.cloneDeep(sendSampling.products[index].refSampling.refQtyUnit),
                })
            );
            //model.refSamplingAnalysisTemp.refUserCompany = lodash.cloneDeep(sendSampling.refUserCompany);
            model.refSamplingAnalysisTemp.refUser = lodash.cloneDeep(sendSampling.refUser);
            model.refSamplingAnalysisTemp.refOfficer = lodash.cloneDeep(store.state.resource.auth.info?.user);
            model.refSamplingAnalysisTemp.products.push(...products);
        }).finally(() => data.isLoadDefaultFormDone = true);
    }
};